import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

import { useSelector, useDispatch } from '../../store/utils';
import { variablesChange } from '../../store/actions';
import { DialogClose } from '../../atoms/dialog-close';

type Props = {
  id: string;
  name: string;
};

export const RfidCardEdit = ({ id, name }: Props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const rfidCards = useSelector((state) => state.variables.RFID_CARDS);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [cardName, setCardName] = useState('');

  const handleOpen = () => {
    setCardName(name);
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleSave = () => {
    const existing = rfidCards?.[id];
    if (!existing) return;
    dispatch(
      variablesChange({
        RFID_CARDS: {
          ...rfidCards,
          [id]: { ...existing, name: cardName.trim() },
        },
      })
    );
    handleClose();
  };

  return (
    <>
      <IconButton size="small" onClick={handleOpen}>
        <EditIcon fontSize="small" />
      </IconButton>

      <Dialog open={dialogOpen} onClose={handleClose} fullWidth maxWidth="xs">
        <DialogTitle>
          <FormattedMessage
            id="wallbox_rfid.edit.dialog.title"
            defaultMessage="Upravit RFID kartu"
          />
        </DialogTitle>
        <DialogClose onClose={handleClose} />

        <DialogContent>
          <TextField
            label={intl.formatMessage({
              id: 'wallbox_rfid.dialog.name_label',
              defaultMessage: 'Název karty',
            })}
            value={cardName}
            onChange={(e) => setCardName(e.target.value)}
            autoFocus
            fullWidth
            sx={{ mt: 1 }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>
            <FormattedMessage
              id="wallbox_rfid.dialog.cancel"
              defaultMessage="Zrušit"
            />
          </Button>
          <Button
            variant="contained"
            disabled={cardName.trim() === ''}
            onClick={handleSave}
          >
            <FormattedMessage
              id="wallbox_rfid.dialog.save"
              defaultMessage="Uložit"
            />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
